import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import "assets/css/home.css";
import { useTranslation } from "react-i18next";
import text_audio_image_en from "assets/img/newDesign/imageSectionVideos/text-to-audio-eng.png";
import text_audio_gif_en from "assets/img/newDesign/imageSectionVideos/text-to-audio-eng.gif";
import text_audio_gif_ar from "assets/img/newDesign/imageSectionVideos/text-to-audio-ar.gif";
import text_audio_image_ar from "assets/img/newDesign/imageSectionVideos/text-to-audio-ar.png";
import split_audio from "assets/img/newDesign/imageSectionVideos/Split-audio.gif";
import split_audio_img from "assets/img/newDesign/imageSectionVideos/Split-audio.png";
import text_speech_ar_gif from "assets/img/newDesign/imageSectionVideos/Text-to-speech.gif";
import text_speech_en_gif from "assets/img/newDesign/imageSectionVideos/Text-to-speech.gif";
import text_speech_en from "assets/img/newDesign/imageSectionVideos/Text-to-speech.png";
import text_speech_ar from "assets/img/newDesign/imageSectionVideos/Text-to-speech.png";
import enhance_audio from "assets/img/newDesign/imageSectionVideos/Enhance-Audio.gif";
import enhance_audio_img from "assets/img/newDesign/imageSectionVideos/Enhance-Audio.png";
import Marquee from "react-double-marquee";
import { Link } from "react-router-dom";
import ImagesFilterComponent from "views/MediaSection/ImagesFilterComponent";
import { ReactComponent as Crown } from "assets/img/newDesign/Crown.svg";

const AudioTools = () => {
  const { t } = useTranslation();
  let lng = JSON.parse(localStorage.getItem("language"))?.lang;
  const features = [
    {
      name: "Text to Speech",
      arabic_name: "نص الى مقطع صوتي",
      link: "text-speech",
      video: text_speech_en_gif,
      videoAr: text_speech_ar_gif,
      videoH: text_speech_en,
      videoHA: text_speech_ar,
      videom: text_speech_en,
      videomAr: text_speech_ar,
      access: ["Free"],
    },
    {
      name: "Enhance Audio",
      arabic_name: "تقطيع الصوت",
      link: "enhance-audio",
      video: enhance_audio,
      videoH: enhance_audio_img,
      videom: enhance_audio_img,
      videomAr: enhance_audio,
      access: ["Free"],
      icon: Crown,
    },
    {
      name: "Text to Music",
      arabic_name: "كلمات الى موسيقى ",
      link: "audio",
      video: text_audio_gif_en,
      videoAr: text_audio_gif_ar,
      videoH: text_audio_image_en,
      videoHA: text_audio_image_ar,
      videom: text_audio_image_en,
      videomAr: text_audio_image_en,
      access: ["Basic"],
    },
    {
      name: "Split Audio",
      arabic_name: "فصل الصوت",
      link: "split-audio",
      video: split_audio,
      videoH: split_audio_img,
      videom: split_audio_img,
      videomAr: split_audio,
      access: ["Basic"],
      icon: Crown,
    },
  ];
  return (
    <div
      style={{
        gap: "20px",
        padding: "0px",
        height: "calc(100vh - 110px)",
        position: "relative",
      }}
      className="page_wrapper border-radius-top"
    >
      <div style={{ padding: "0px" }} className="image_gen_outer_wraaper border-radius-top" id="image_gen_outer_wraaper">
        <ImagesFilterComponent />
        <h2
          style={{
            fontWeight: "600",
            color: "black",
            fontSize: "1.5rem",
            textAlign: lng === "arab" ? "right" : "left",
            marginBottom: "0",
          }}
        >
          {t("Audio Tools")}
        </h2>

        <div
          style={{
            margin: null,
            maxWidth: null,
            padding: "40px 20px 15px 15px",
          }}
          className="write_body border-radius-top"
        >
          <div
            style={{
              paddingBottom: "15px",
              minHeight: "300px",
              justifyContent: "flex-start",
            }}
            className="all_images_wrapper row"
          >
            {features?.length === 0 ? (
              <label>{t("No Items Found")}</label>
            ) : (
              features?.map((item, i) => (
                <VideoCard
                  key={i}
                  title={lng === "arab" ? item?.arabic_name : item?.name}
                  index={i}
                  videoAr={item?.videoAr}
                  video={item?.video}
                  thumb={lng === "arab" ? item?.videoHA || item?.videoH : item?.videoH}
                  videom={item?.videom}
                  videomAr={item?.videomAr}
                  access={item?.access}
                  goTo={item?.link}
                  Icon={item?.icon}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioTools;

const VideoCard = ({ title, video, index, goTo, thumb, videoAr, access, videom, videomAr, Icon }) => {
  const { t } = useTranslation();
  let lng = JSON.parse(localStorage.getItem("language"))?.lang;
  const cardRef = useRef();
  const textRef = useRef();
  const marqRef = useRef();
  const [displayMarq, setDisplayMarq] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [imageLoading, setImageLoading] = useState(false);
  const [hovering, setHovering] = useState(false);
  const [media, setMedia] = useState("");

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  useEffect(() => {
    if (cardRef.current && textRef.current) {
      if (cardRef.current.offsetWidth - textRef.current.offsetWidth <= 15) {
        setDisplayMarq(true);
      }
    }
    if (cardRef.current && marqRef.current) {
      if (cardRef.current.offsetWidth - marqRef.current.offsetWidth > 15) {
        setDisplayMarq(false);
      }
    }
  }, [cardRef.current?.offsetWidth, title, textRef.current, width, marqRef.current, location.pathname]);

  useEffect(() => {
    if (location.pathname.includes("images")) {
      setMedia("images");
    } else if (location.pathname.includes("audios")) {
      setMedia("audios");
    } else if (location.pathname.includes("videos")) {
      setMedia("videos");
    }
  }, [location.pathname]);
  return (
    <div
      onMouseOver={() => setHovering(true)}
      onMouseOut={() => setHovering(false)}
      key={index}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      className={"col-xl-4 col-lg-4 col-md-6 col-sm-6"}
    >
      <Link style={{ width: "100%", borderRadius: "1.2rem" }} ref={cardRef} to={`/photogen/${media}/${goTo}`} className="">
        {imageLoading && (
          <div className="">
            <Spinner animation="grow" />
          </div>
        )}
        {access.map((item, i) => (
          <span
            key={i}
            style={{
              position: "absolute",
              zIndex: 10,
              background: item === "Pro" ? "#FFC2C2" : item === "Basic" ? "#B6FFAA" : item === "Starter" ? "#FFEDAF" : "#E4EFFF",
              borderRadius: "15px",
              right: lng === "arab" ? null : "35px",
              left: lng === "arab" ? "35px" : null,
              top: "15px",
              color: item === "Pro" ? "#7D0D0D" : item === "Basic" ? "#139A07" : item === "Starter" ? "#9A4E07" : "#07549A",
              fontSize: "0.6rem",
              padding: "3px 10px",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {item === "Pro" && <Icon />}
            {t(item)}
          </span>
        ))}
        {/* <GifPlayer gif={video}/> */}
        <img
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "1.2rem",
            transition: "transform 0.4s ease-out, height 0.4s ease-out",

            transform: hovering ? "scale(1)" : "scale(0.95)",
          }}
          src={width <= 900 ? (lng === "arab" ? videomAr : videom) : !hovering ? thumb : lng === "arab" ? videoAr || video : video}
          alt={title}
        />

        <div style={{ width: "100%" }} className="cards_mobile">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: hovering ? "1.2rem" : null,
            }}
            className={`videoBtnEffect`}
          >
            {!displayMarq ? (
              <span>
                <label style={{ whiteSpace: "nowrap" }} ref={textRef}>
                  {title}
                </label>
              </span>
            ) : (
              <div className={lng === "arab" ? "cssmarquee_arab" : "cssmarquee"} style={{ direction: "ltr" }}>
                <Marquee speed={0.025} delay={0} childMargin={15} direction={lng === "arab" ? "right" : "left"} className="label_of_title">
                  <label ref={marqRef}>{title}</label>
                </Marquee>
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
